export default __webpack_public_path__ + "static/media/004-B-entretienmaison.71258a61.svg";